import { useQuery } from 'react-query';
import { dataFetch, DIGGER_API_SUFFIX } from '../../axios/customAxios';

export const useGetDashboards = (identifier: string, name: string) => useQuery(
  [`dashboards_${identifier}`],
  () => dataFetch.get(`${DIGGER_API_SUFFIX}dashboard?name=${name}&rows=10`).then((res) => res.data),
);

export const useGetDashboardById = (identifier: string, dashboardId: number | undefined) => useQuery(
  [`dashboards_${identifier}`],
  () => dashboardId && dataFetch.get(`/dashboard/${dashboardId}`).then((res) => res.data),
);
